<div class="masthead bg-white pl-md-5 pr-md-5">
    <div class="row align-items-center">
        <div class="col">
            <p class="mb-0 h3 pb-4 pt-4">
                <i class="fa fa-user-o mr-3"></i>
                Manage users
            </p>
        </div>
        <div class="col text-right align-items-center d-flex justify-content-end">
            <button class="btn btn-primary ml-3 btn-sm" (click)="downloadTemplateFile()" *userRoleToggle="['SuperAdmin']">
                Download template <i class="fa fa-file ml-2"></i>
            </button>
            <usersimportfile #import (uploadCompleteEvent)="setPageSize(selectedPageSize)" *userRoleToggle="['SuperAdmin']"></usersimportfile>
            <ng-container *ngFor="let item of headerButtons; let i = index">
                <button id="i" class="btn btn-primary ml-3 btn-sm" (click)="addClicked()" *ngIf="item.label.length > 0 && !item.disable">{{item.label}}<i [ngClass]="item.btnClass" class="ml-2"></i></button>
            </ng-container>
            <form class="form" [formGroup]="userSearch" novalidate>
                <div class="form-group d-inline-block mb-0 ml-3">
                    <input type="text" [(ngModel)]="searchTerm" class="form-control" formControlName="search" placeholder="Search users..." />
                </div>
            </form>
        </div>
    </div>
</div>

<div class="container mt-5">
    <div class="row">
        <div class="col-md-12">
            <div>
            <label>Page Size :</label>
            <select (change)="setPageSize($event.target.value)" [(ngModel)]="selectedPageSize">
                <option *ngFor="let pageSize of pageSizes" value={{pageSize.id}}>
                    {{pageSize.text}}
                </option>
            </select>
            </div>
            <div class="card mb-4" *ngFor="let group of groupedUsers">
                <div class="card-header text-white bg-primary">
                    <div class="row">
                        <div class="col-sm-8">
                            <p class="h3 m-0">{{group.roleName}}</p>
                        </div>
                        <div class="col-sm-4 text-right">
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <table class="table mb-0">
                        <colgroup>
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>User Name/Email</th>
                                <th>Company</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let user of group.users">
                                <td [ngClass]="{'text-muted strikethrough': user.disabled}">{{user.firstName + ' ' + user.lastName}}</td>
                                <td [ngClass]="{'text-muted strikethrough': user.disabled}"><strong>{{user.userName}}</strong></td>
                                <td [ngClass]="{'text-muted strikethrough': user.disabled}">{{user.companyName}}</td>
                                <td class="text-right">
                                    <i class="btn btn-primary-invert fa fa-pencil" (click)="editClicked(user)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div *ngIf="selectedPageSize !=0" class="text-right">
                <ul *ngIf="pages && pages.length" class="paging">
                    <li [ngClass]="{disabled:currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li [ngClass]="{disabled:currentPage === 1}">
                        <a (click)="setPage(currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pages" [ngClass]="{active:currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:currentPage === totalPages}">
                        <a (click)="setPage(currentPage + 1)">Next</a>
                    </li>
                    <li [ngClass]="{disabled:currentPage === totalPages}">
                        <a (click)="setPage(totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<downloadfile #download></downloadfile>
